import React from 'react';
import { useTranslation } from 'react-i18next';

import { Chip, ChipProps } from '@mui/material';

interface ProgressChipProps {
	progress: number;
}

function ProgressChip({ progress }: ProgressChipProps) {
	const { t } = useTranslation();
	let chipProps: {
		label: string;
		color: ChipProps['color'];
	};

	switch (progress) {
		case 0:
			chipProps = { label: t('resources.new'), color: 'error' };
			break;
		case 100:
			chipProps = { label: t('resources.completed'), color: 'success' };
			break;
		default:
			chipProps = { label: t('resources.inProcess'), color: 'info' };
			break;
	}

	return (
		<Chip
			{...chipProps}
			sx={{
				width: 'fit-content',
				height: 'unset',
				'& .MuiChip-label': {
					fontSize: { xs: '12px', sm: '16px' },
				},
			}}
		/>
	);
}

export default ProgressChip;
